import { render, staticRenderFns } from "./CreateCheck.vue?vue&type=template&id=1d72dd76"
import script from "./CreateCheck.vue?vue&type=script&lang=js"
export * from "./CreateCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports